import React, { useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { feeddataActions } from "../../actions";

import ShowPhoto from "./ShowPhoto";
import ShowContent from "./ShowContent";
import ShowEbook from "./ShowEbook";

import LoadData from "../../components/Error/LoadData";

import BreadCrumAsync from "../../components/Utils/BreadCrumASync";
function Show() {
    const dispatch = useDispatch();
    const feedData = useSelector((state) => state.feedData);
    let { topicId } = useParams();
    var CategoryNoList = ["history", "rules", "regularity"];

    useEffect(() => {
        if (topicId != "") {
            async function feedData() {
                await dispatch(
                    feeddataActions.feedData(`/api/info/show/${topicId}`)
                );
            }
            feedData();
        }
    }, [topicId]);
    if (feedData.data.content_type && feedData.data.content_type == "onlypdf") {
        window.location.href = `${feedData.data.show && feedData.data.show.ndata
            }`;
    } else if (feedData.fetchSuccess && feedData.data) {
        return (
            <div className="bg-gray-50 py-2  min-h-screen">
                {/* sm:px-6 lg:px-8 */}
                <div className="max-w-7xl mx-auto ">
                    <BreadCrumAsync />
                </div>
                <div className="rounded-lg shadow-lg p-1 lg:p-2 xl:p-3 my-2 max-w-7xl bg-white mx-auto">
                    {feedData.data.gtype == "G" ? (
                        <ShowPhoto data={feedData.data} />
                    ) : (
                        <Fragment>
                            {feedData.data.show &&
                                feedData.data.show.Category == "E_Book" ? (
                                <ShowEbook data={feedData.data} />
                            ) : (
                                <ShowContent data={feedData.data} />
                            )}
                        </Fragment>
                    )}
                </div>
            </div>
        );
    }
    return (
        <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <center>
                <LoadData />
            </center>
        </div>
    );
}

export default Show;
